import React from "react";

import "./CounterCardSection.scss";

export default class CounterCardSection extends React.Component {
    renderCompact(value, type) {
        return (
            <div className="counter-card-section d-flex align-items-center">
                <div className="counter-card d-flex align-items-center justify-content-center">
                    <div className="counter-card-separator"></div>

                    <div className={`counter-card-text${value >= 100 ? "-small" : ""}`}>{value}</div>
                </div>

                <div className="counter-card-label">{type}</div>
            </div>
        );
    }

    renderFullSize(value, type) {
        return (
            <div className="counter-card-section d-flex flex-column">
                <div className="counter-card d-flex align-items-center justify-content-center">
                    <div className="counter-card-separator"></div>

                    <div className={`counter-card-text${value >= 100 ? "-small" : ""}`}>{value}</div>
                </div>

                <div className="counter-card-label">{type}</div>
            </div>
        );
    }

    render() {
        const {compact, value, type} = this.props;
        const content = compact ? this.renderCompact(value, type) : this.renderFullSize(value, type);

        return content;
    }
}
